///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { GridHelper, Vector3 } from "three";
import { IComponent, components, Viewer } from "@inweb/viewer-three";

class GridHelperComponent implements IComponent {
  private viewer: Viewer;
  private gridHelper: GridHelper;

  constructor(viewer: Viewer) {
    this.gridHelper = new GridHelper(10, 20, 0x444444, 0xaaaaaa);
    this.viewer = viewer;
    this.viewer.on("initialize", this.syncHelper);
    this.viewer.on("geometryend", this.syncHelper);
    this.viewer.on("clear", this.syncHelper);
  }

  dispose() {
    this.gridHelper.removeFromParent();
    this.gridHelper.dispose();

    this.viewer.off("initialize", this.syncHelper);
    this.viewer.off("geometryend", this.syncHelper);
    this.viewer.off("clear", this.syncHelper);
  }

  syncHelper = () => {
    this.gridHelper.removeFromParent();

    if (this.viewer.extents.isEmpty()) return;

    const size = this.viewer.extents.getSize(new Vector3()).multiply(this.viewer.camera.up).length();
    const center = this.viewer.extents.getCenter(new Vector3());

    const upY = new Vector3(0, 1, 0);
    const up = new Vector3().copy(this.viewer.camera.up);

    this.gridHelper.scale.setScalar(size);
    this.gridHelper.position.copy(center);
    this.gridHelper.quaternion.setFromUnitVectors(upY, up);

    this.viewer.helpers.add(this.gridHelper);
  };
}

components.registerComponent("GridHelperComponent", (viewer) => new GridHelperComponent(viewer));
